export default {
      id: "sidebar_monitoring-usage",
      viewBox: "0 0 20 20",
      url: "assets/" + "sprite.svg#sidebar_monitoring-usage",
      toString: function () {
        return this.url;
      }
    }